import { render, staticRenderFns } from "./modalDirectorio.vue?vue&type=template&id=59351cce"
import script from "./modalDirectorio.vue?vue&type=script&lang=js"
export * from "./modalDirectorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports